module.exports = __webpack_public_path__ + "static/img/003.32d45a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/intellectual_property/003.jpg
// module id = 1uAg
// module chunks = 0